var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, List, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FieldArray } from 'formik';
import { useAccount } from 'shared/domains/users';
import { AccessListItem } from './AccessListItem';
import { AccessManagementListState } from './AccessManagementListState';
import { useAccessManagementList } from './useAccessManagementList';
export function AccessManagementList(props) {
    const { entryId, parentId } = props;
    const account = useAccount();
    const { userId } = account.data;
    const { userAcls, teamAcls, loading, error, refetch } = useAccessManagementList({ entryId, parentId });
    const empty = userAcls.value.filter((acl) => acl.visible).length === 0 &&
        teamAcls.value.filter((acl) => acl.visible).length === 0;
    if (error) {
        return (<AccessManagementListState icon={<Falcon icon="circle-exclamation" $size={32} $color="swatches.gray.400"/>} title={t({
                message: 'Error',
                comment: 'Access management form - Error title',
            })} subtitle={t({
                message: 'Users and teams could not be loaded.',
                comment: 'Access management form - Error description',
            })} actions={<Button type="button" appearance="secondary" size="xs" onClick={() => __awaiter(this, void 0, void 0, function* () { return refetch(); })}>
            <Trans comment="Access management form - Retry button label">Retry</Trans>
          </Button>}/>);
    }
    if (loading) {
        return <AccessManagementListState icon={<Loader size={14}/>}/>;
    }
    if (empty) {
        return (<AccessManagementListState icon={<Falcon icon="user-group" $size={32} $color="swatches.gray.400"/>} title={t({
                message: 'Not shared',
                comment: 'Access management form - No users or teams title',
            })} subtitle={t({
                message: 'Not shared with any members or teams.',
                comment: 'Access management form - No users or teams description',
            })}/>);
    }
    return (<List>
      <FieldArray name={teamAcls.name} render={(helpers) => teamAcls.value.map((team, index) => (<AccessListItem key={team.id} type="team" visible={team.visible} fieldName={team.fieldName} onRemove={() => helpers.remove(index)} title={team.title} subtitle={team.subtitle} hasAccessToParentFolder={team.hasAccessToParentFolder}/>))}/>
      <FieldArray name={userAcls.name} render={(helpers) => userAcls.value.map((user, index) => (<AccessListItem key={user.id} type="user" visible={user.id !== userId && user.visible} fieldName={user.fieldName} onRemove={() => helpers.remove(index)} title={user.title} subtitle={user.subtitle} hasAccessToParentFolder={user.hasAccessToParentFolder}/>))}/>
    </List>);
}
